export const CartNavigation = Object.freeze({
    PAYMENT_METHOD_FORM: "ADD_PAYMENT_METHOD_FORM",
    CONFIRMATION: "CONFIRMATION",
    SHIPPING_ADDRESS_FORM: "SHIPPING_ADDRESS_FORM",
    MAIN: "MAIN",
});
